import { get } from "../common/apiMethods";

export const notifyUserSignupEvent = () => {
  return get(`/api/user/signup/success`);
};
